




import { EVENTS } from '@empathybroker/ebx-gluon';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class CdlBackgroundClose extends Vue {
  onClick() {
    this.$x.emit(EVENTS.CloseEmpathyX);
  }
}
